var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:[
    'font-weight-medium',
    `${_vm.getMaterialColor(_vm.color, { output: 'word' })}--text `,
    'text--darken-4',
  ],attrs:{"color":`${_vm.getMaterialColor(_vm.color, {
    output: 'word',
  })} lighten-4`,"label":_vm.label,"small":_vm.small,"x-small":_vm.xSmall},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.iconLeft)?_c('v-icon',{attrs:{"left":"","small":_vm.small || _vm.smallIcon,"x-small":_vm.xSmall,"color":`${_vm.getMaterialColor(_vm.color, {
      output: 'word',
    })} darken-4`}},[_vm._v(" mdi-"+_vm._s(_vm.iconLeft)+" ")]):_vm._e(),_c('span',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(_vm.text))]),(_vm.iconRight)?_c('v-icon',{attrs:{"right":"","small":_vm.small || _vm.smallIcon,"color":`${_vm.getMaterialColor(_vm.color, {
      output: 'word',
    })} darken-4`}},[_vm._v(" mdi-"+_vm._s(_vm.iconRight)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }